import { TicketSalesResultType } from '@api';
import { TouringDataTable, useManageTableContext } from '@common';
import { useTranslation } from 'react-i18next';
import { useTicketSalesSellable, useTicketSalesTableColumns } from './hooks';

type TicketSalesTablePropsType = {
  results: TicketSalesResultType[];
  isPending: boolean;
  onUpdateSellable: (ticketSalesId: string, ticketsSellable: number) => void;
};

export const TicketSalesTable: React.FC<TicketSalesTablePropsType> = ({
  results,
  isPending,
  onUpdateSellable,
}) => {
  const { t } = useTranslation('ticketSales');

  useTicketSalesSellable(results);
  const { columns } = useTicketSalesTableColumns({ onUpdateSellable });
  const {
    tableArguments: { pagination, sorting },
  } = useManageTableContext();

  return (
    <TouringDataTable<TicketSalesResultType>
      columns={columns}
      records={results}
      idAccessor="ticketSalesId"
      noRecordsText={t('NO_RESULTS')}
      fetching={isPending}
      {...pagination}
      {...sorting}
    />
  );
};
